import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const PRODUCTS_API_PATH = '/api/products';

// Function to fetch all products
const getAllProducts = async () => {
  const response = await axios.get(`${API_BASE_URL}${PRODUCTS_API_PATH}/all`);
  return response.data.data;
};

// Function to fetch all products for a specific store
const fetchProducts = async (
  storeId = null,
  { page = 1, limit = 25, search, category, subcategory, supplierId, noCategory, noSubcategory, quickPickOnly } = {}
) => {
  const params = { page, limit };
  if (storeId) params.storeId = storeId;
  if (search) params.search = search;
  if (category) params.category = category;
  if (subcategory) params.subcategory = subcategory;
  if (supplierId) params.supplierId = supplierId;
  if (noCategory) params.noCategory = true;
  if (noSubcategory) params.noSubcategory = true;
  if (quickPickOnly) params.quickPickOnly = true;

  const response = await axios.get(`${API_BASE_URL}${PRODUCTS_API_PATH}`, {
    params
  });
  return response.data;
};

// Function to search products by name/SKU/barcode within a specific store
const searchProducts = async (storeId, searchTerm = '', options = {}) => {
  if (!storeId) {
    throw new Error('storeId is required to search products.');
  }
  const params = { storeId, search: searchTerm };
  if (options?.searchMode) {
    params.searchMode = options.searchMode;
  }
  if (options?.lookupContext) {
    params.lookupContext = options.lookupContext;
  }
  const response = await axios.get(`${API_BASE_URL}${PRODUCTS_API_PATH}`, {
    params,
  });
  return response.data.data;
};

const getProductById = async (id, storeId) => {
  const response = await axios.get(`${API_BASE_URL}${PRODUCTS_API_PATH}/${id}`, {
    params: storeId ? { storeId } : undefined,
  });
  return response.data.data;
};

const createProduct = async (productData) => {
  const response = await axios.post(`${API_BASE_URL}${PRODUCTS_API_PATH}`, productData);
  return response.data.data;
};

const updateProduct = async (id, productData) => {
  const response = await axios.put(`${API_BASE_URL}${PRODUCTS_API_PATH}/${id}`, productData);
  return response.data.data;
};

const deleteProduct = async (id) => {
  await axios.delete(`${API_BASE_URL}${PRODUCTS_API_PATH}/${id}`);
  return id;
};

const adjustStock = async (productId, { storeId, newQuantity, reason }) => {
  const response = await axios.put(`${API_BASE_URL}${PRODUCTS_API_PATH}/${productId}/stock`, {
    storeId, newQuantity, reason
  });
  return response.data.data;
};

const inventoryService = {
  getAllProducts,
  fetchProducts,
  searchProducts,
  getProductById,
  createProduct,
  updateProduct,
  deleteProduct,
  adjustStock,
};

export default inventoryService;
